import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Popover, Icon } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  boxWording: {
    fontSize: '1rem',
    color: theme.palette.darkGrey.main,
    cursor: 'pointer',
  },
  boxItemEdit: {
    fontSize: '1.5rem',
    color: theme.palette.informative.main,
    cursor: 'pointer',
    marginRight: '5px',
  },
  boxItemDelete: {
    fontSize: '1.5rem',
    color: theme.palette.negative.main,
    cursor: 'pointer',
    marginRight: '5px',
  },
}))
const CommentReplyMenu = ({
  isEditBoxOpen,
  anchorEl,
  onClose,
  onClickEdit,
  onClickDelete,
}) => {
  const classes = useStyles()
  return (
    <Popover
      open={Boolean(isEditBoxOpen)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      classes={{
        paper: 'p-4',
      }}
    >
      <div
        className={clsx(classes.boxWording, 'flex items-center p-2')}
        onClick={onClickEdit}
      >
        <Icon className={clsx(classes.boxItemEdit)}>edit</Icon>
        <FormattedMessage id="notificationTimeline.card.comment.edit.button" />
      </div>
      <div
        className={clsx(classes.boxWording, 'flex items-center p-2')}
        onClick={onClickDelete}
      >
        <Icon className={clsx(classes.boxItemDelete)}>delete</Icon>
        <FormattedMessage id="notificationTimeline.card.comment.delete.button" />
      </div>
    </Popover>
  )
}

export default React.memo(CommentReplyMenu)
